





















































































































































































































































































































































































































































import { Prop, Component, Vue } from 'vue-property-decorator'

@Component
export default class AvatarOne extends Vue {
    @Prop({ type: Number, default: 500 }) readonly size!: number
}
